const data_wall_event = {
  POST: {
    en: 'Comment',
    fr: 'Commentaire',
    icon: 'chat',
    id: 1,
  },
  UPDATE: {
    en: 'Update',
    fr: 'Modification',
    icon: 'pencil',
    id: 2,
  },
  FLASH: {
    en: 'Event',
    fr: 'Evénement',
    icon: 'flash',
    id: 3,
  },
  DANGER: {
    en: 'Issue',
    fr: 'Incident',
    icon: 'warning',
    id: 4,
  },
  GREET: {
    en: 'Interaction',
    fr: 'Contact',
    icon: 'users',
    id: 5,
  },
  PINNED: {
    en: 'Pinned',
    fr: 'Epinglé',
    icon: 'pin',
    id: 6,
  },
};

export default data_wall_event;
